import { useState } from 'react'
import { useSelector } from 'react-redux'
import './directory.css'

const SPECIALISTS = [
  {
    id: 1,
    name: 'COHEA – Curly Hair Specialist',
    city: 'Brussels',
    specialty: 'Curly · Coily · Afro',
    address: 'Rue de Portugal 1, 1060 Bruxelles',
    phone: '+32 123 456 789',
    website: 'https://cohea.be/',
    websiteLabel: 'cohea.be',
    photo:
      'https://images.unsplash.com/photo-1595475207225-428b62bda831?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 2,
    name: 'SUNAE – Curly Hair Specialist',
    city: 'Brussels',
    specialty: 'Curly · Wavy',
    address: 'Rue du Postillon 8, 1180 Uccle',
    phone: '+32 456 789 1234',
    website: 'https://www.instagram.com/reel/DXmkIl8DOGR/',
    websiteLabel: 'instagram.com',
    photo:
      'https://images.unsplash.com/photo-1562322140-8baeececf3df?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 3,
    name: 'Maison Raphaelis',
    city: 'Brussels',
    specialty: 'Cut · Colour · Style',
    address: 'Rue Saint-Michel 25, 1000 Bruxelles',
    phone: '+32 2 217 54 21',
    website: 'https://raphaeliscoiffure.be/',
    websiteLabel: 'raphaeliscoiffure.be',
    photo:
      'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 4,
    name: 'Hana.B Paris',
    city: 'Paris',
    specialty: 'Curly · Treatment · VIP',
    address: '47 Rue des Belles Feuilles, 75016',
    phone: '+33 9 56 12 64 09',
    website: 'https://www.hanabparis.com/',
    websiteLabel: 'hanabparis.com',
    photo:
      'https://images.unsplash.com/photo-1492106087820-71f1a00d2b11?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 5,
    name: 'David Mallett',
    city: 'Paris',
    specialty: 'Luxury · Cut · Colour',
    address: '14 Rue Notre Dame des Victoires, 75002',
    phone: '+33 1 40 20 00 23',
    website: 'https://david-mallett.com/',
    websiteLabel: 'david-mallett.com',
    photo:
      'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 6,
    name: 'Hair Studio by Anissa',
    city: 'Paris',
    specialty: 'Natural · Protective',
    address: '154 Rue Saint-Honoré, 75001',
    phone: '+33 1 40 20 40 19',
    website: 'https://hairstudiobyanissa.com/',
    websiteLabel: 'hairstudiobyanissa.com',
    photo:
      'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 7,
    name: 'Salon The Hand of God',
    city: 'Kinshasa',
    specialty: 'Afro · Braids · Styling',
    address: 'Bd Du 30 Juin, Kinshasa',
    phone: '+243 852 943 267',
    website: 'https://www.facebook.com/salonthehandofgodchezsymphorien/',
    websiteLabel: 'facebook.com',
    photo:
      'https://images.unsplash.com/photo-1559599101-f09722fb4948?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 8,
    name: 'Spa David Sawah',
    city: 'Kinshasa',
    specialty: 'Spa · Hair · Wellness',
    address: 'Av Lt. Colonel Lukusa, Kinshasa',
    phone: '+243 998 222 229',
    website: 'https://www.spa-davidsawah.com/',
    websiteLabel: 'spa-davidsawah.com',
    photo:
      'https://images.unsplash.com/photo-1470259078422-826894b933aa?w=400&h=400&fit=crop&q=80',
  },
  {
    id: 9,
    name: "Salon L'Oiseau d'Or",
    city: 'Kinshasa',
    specialty: 'Cut · Colour · Afro',
    address: '16 Sergent Moke, Kinshasa',
    phone: '+243 812 149 920',
    website: 'https://oiseaudor.com/',
    websiteLabel: 'oiseaudor.com',
    photo:
      'https://images.unsplash.com/photo-1582095133179-bfd08e2195b3?w=400&h=400&fit=crop&q=80',
  },
]

const CITIES = ['All', 'Brussels', 'Paris', 'Kinshasa']

function getTranslationText(keyPath, data = {}, lang = 'EN') {
  const validLangs = ['EN', 'FR', 'NL', 'SW']
  const selected = validLangs.includes(String(lang || 'EN').toUpperCase())
    ? String(lang || 'EN').toUpperCase()
    : 'EN'

  const keys = keyPath.split('.')
  let result = data
  for (const key of keys) {
    result = result?.[key]
    if (Array.isArray(result)) result = result[0]
  }

  if (result && typeof result === 'object') {
    return result[selected] ?? result.EN ?? 'Text not found'
  }

  return result || 'Text not found'
}

function getInitials(name) {
  return name
    .split(' ')
    .filter((word) => /[A-Za-z]/.test(word))
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('')
}

const IconPin = () => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' />
    <circle cx='12' cy='10' r='3' />
  </svg>
)

const IconPhone = () => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.06 12a19.79 19.79 0 0 1-3-8.59A2 2 0 0 1 3 1.16h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' />
  </svg>
)

const IconGlobe = () => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <circle cx='12' cy='12' r='10' />
    <line x1='2' y1='12' x2='22' y2='12' />
    <path d='M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' />
  </svg>
)

function SpecialistCard({ specialist, index }) {
  const [imgError, setImgError] = useState(false)
  const initials = getInitials(specialist.name)
  const translations = useSelector((state) => state.translationsData) || {}
  const language = useSelector((state) => state.language)

  return (
    <div
      className='directory-card'
      style={{ animationDelay: `${index * 0.05}s` }}
    >
      <div className='directory-photo-container'>
        {!imgError ? (
          <img
            src={specialist.photo}
            alt={specialist.name}
            className='directory-photo'
            onError={() => setImgError(true)}
          />
        ) : (
          <div className='directory-photo-fallback'>{initials}</div>
        )}

        <div className='directory-city-overlay'>
          <span className='directory-city-dot' />
          {specialist.city}
        </div>
      </div>

      <div className='directory-card-body'>
        <div className='directory-card-name'>{specialist.name}</div>
        <div className='directory-specialty'>{specialist.specialty}</div>

        <div className='directory-meta'>
          <div className='directory-meta-row'>
            <span className='directory-meta-icon'>
              <IconPin />
            </span>
            <span className='directory-meta-text'>{specialist.address}</span>
          </div>

          <div className='directory-meta-row'>
            <span className='directory-meta-icon'>
              <IconPhone />
            </span>
            <span className='directory-meta-text'>
              <a href={`tel:${specialist.phone.replace(/\s/g, '')}`}>
                {specialist.phone}
              </a>
            </span>
          </div>

          <div className='directory-meta-row'>
            <span className='directory-meta-icon'>
              <IconGlobe />
            </span>
            <span className='directory-meta-text'>
              <a
                href={specialist.website}
                target='_blank'
                rel='noopener noreferrer'
              >
                {specialist.websiteLabel}
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className='directory-card-footer'>
        <a
          className='directory-btn directory-btn-solid'
          href={specialist.website}
          target='_blank'
          rel='noopener noreferrer'
        >
          {getTranslationText('directory.bookNow', translations, language)}
        </a>
      </div>
    </div>
  )
}

export default function HairSpecialists({ onBack }) {
  const translations = useSelector((state) => state.translationsData) || {}
  const language = useSelector((state) => state.language)
  const [activeCity, setActiveCity] = useState('All')

  const t = (keyPath, replacements = {}) => {
    let value = getTranslationText(keyPath, translations, language)
    if (typeof value === 'string') {
      Object.entries(replacements).forEach(([key, replacement]) => {
        value = value.replace(
          new RegExp(`\\{${key}\\}`, 'g'),
          String(replacement),
        )
      })
    }
    return value
  }

  const filtered =
    activeCity === 'All'
      ? SPECIALISTS
      : SPECIALISTS.filter((specialist) => specialist.city === activeCity)

  return (
    <div className='directory-root'>
      <div className='directory-header'>
        <div className='directory-header-left'>
          {onBack && (
            <button
              type='button'
              className='directory-back'
              onClick={onBack}
              aria-label={t('directory.goBack')}
            >
              ←
            </button>
          )}

          <span className='directory-header-title'>
            {t('directory.headerTitle')}
          </span>
        </div>

        <span className='directory-header-count'>
          {t('directory.headerCount', { count: filtered.length })}
        </span>
      </div>

      <div className='directory-filter-bar'>
        <span className='directory-filter-label'>
          {t('directory.filterLabel')}
        </span>

        <div className='directory-city-pills'>
          {CITIES.map((city) => (
            <button
              key={city}
              type='button'
              className={`directory-city-pill${
                activeCity === city ? ' active' : ''
              }`}
              onClick={() => setActiveCity(city)}
            >
              {city === 'All' ? t('directory.all') : city}
            </button>
          ))}
        </div>
      </div>

      <div className='directory-results-label'>
        {activeCity === 'All'
          ? t('directory.results.all', { count: filtered.length })
          : t('directory.results.city', {
              city: activeCity,
              count: filtered.length,
              plural: filtered.length === 1 ? '' : 's',
            })}
      </div>

      <div className='directory-grid'>
        {filtered.length === 0 ? (
          <div className='directory-empty'>{t('directory.results.empty')}</div>
        ) : (
          filtered.map((specialist, index) => (
            <SpecialistCard
              key={specialist.id}
              specialist={specialist}
              index={index}
            />
          ))
        )}
      </div>

      <div className='directory-bottom-padding' />
    </div>
  )
}
